require('./js/main');
require('./scss/main.scss');
// Removed in favor of directly importing dependencies
// let ctx = require.context('./js/lib', false, /\.ts|js$/);
// ctx.keys().forEach(ctx);